import React, {useCallback, useEffect, useState} from 'react';
import {selectLocalPeerRoleName, useHMSActions, useHMSStore, useHMSVanillaStore} from '@100mslive/react-sdk';
import {IconButton, Tooltip} from '@100mslive/react-ui';
import {PipIcon} from '@100mslive/react-icons';
import ActivatedPIP from './ActivatedPIP';
import {PictureInPicture} from './PIPManager';
import {DEFAULT_HLS_VIEWER_ROLE} from '../common/constants';
import { MediaSession } from "./SetupMediaSession";
/**
 * shows a button which when clicked shows some videos in PIP, clicking
 * again turns it off.
 */
 const PIPComponent = () => {
  const localPeerRole = useHMSStore(selectLocalPeerRoleName);
  const [isPipOn, setIsPipOn] = useState(PictureInPicture.isOn());
  const hmsActions = useHMSActions();
  const store = useHMSVanillaStore();
  const onPipToggle = useCallback(() => {
    if (!isPipOn) {
      PictureInPicture.start(hmsActions, setIsPipOn).catch(err =>
        console.error("error in starting pip", err)
      );
      MediaSession.setup(hmsActions, store);
    } else {
      PictureInPicture.stop().catch(err =>
        console.error("error in stopping pip", err)
      );
    }
  }, [hmsActions, isPipOn, store]);
  useEffect(() => {
    setTimeout(()=> {
      onPipToggle()
    },0)
    return () => {
      PictureInPicture.stop().catch(err =>
        console.error("error in stopping pip on unmount", err)
      );
    };
  }, []);
  if (
    !PictureInPicture.isSupported() ||
    localPeerRole === DEFAULT_HLS_VIEWER_ROLE
  ) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={`${isPipOn ? 'Deactivate' : 'Activate'} Person in Person view`}>
        <IconButton
          active={!isPipOn}
          key="pip"
          onClick={() => setIsPipOn(!isPipOn)}
          data-testid="pip_btn">
          <PipIcon />
        </IconButton>
      </Tooltip>
      {isPipOn && <ActivatedPIP setIsPipOn={setIsPipOn} />}
    </>
  );
};

export default PIPComponent;
